import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      borderWidth: '0',
      borderBottom: '0',
    },
    panel: {
      py: 0,
      borderColor: getThemes(theme).colors.palette.neutral[60],
    },
    button: {
      fontWeight: 'medium',
    },
  });

export const AccordionTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
  });

export default (theme: ThemesKeys) => AccordionTheme(theme);
